import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { SUGGESTION_CARDS_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { SuggestionCardsBlockScenarioContent } from '@front-platform/content-builder';
import {
  SUGGESTION_CARDS_BLOCK_LOADING_VM,
  SuggestionCardsBlockDataSource,
  SuggestionCardsBlockViewModel,
} from './suggestion-cards-block-view-model';

export function toSuggestionCardsPreviewViewModel(
  content: SuggestionCardsBlockScenarioContent,
): SuggestionCardsBlockViewModel {
  const products = content.suggestions as unknown as NonNullable<
    SuggestionCardsBlockViewModel['suggestions']['value']
  >;
  return {
    suggestions: {
      hasValue: true,
      value: [...products],
      isLoading: false,
    },
  };
}

@Injectable()
export class SuggestionCardsBlockPreviewDataSource implements SuggestionCardsBlockDataSource {
  readonly vm$: Observable<SuggestionCardsBlockViewModel> = previewScenarioForBloc$(
    SUGGESTION_CARDS_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return SUGGESTION_CARDS_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<SuggestionCardsBlockScenarioContent>(
        scenario,
        SUGGESTION_CARDS_BLOCK_COMPONENT,
      );
      return content
        ? toSuggestionCardsPreviewViewModel(content)
        : SUGGESTION_CARDS_BLOCK_LOADING_VM;
    }),
  );
}
